import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faLinkedin, faGithub } from "@fortawesome/free-brands-svg-icons";

const ContactMe = () => {
  return (
    <section className="contact">
      <Container>
        <h2 className="contact__title text-center">Let's Connect</h2>
        <Row className="justify-content-center">
          <Col md={4} className="text-center mb-4">
            <a
              target={"_blank"}
              rel="noreferrer"
              href="mailto:vincenzochiovaro194@gmail.com"
              className="contact-link"
            >
              <FontAwesomeIcon
                icon={faEnvelope}
                size="4x"
                className="icon-email"
              />
              <span className="contact-link__label">Email</span>
            </a>
          </Col>
          <Col md={4} className="text-center mb-4">
            <a
              data-testid="linkedin__btn-link"
              rel="noreferrer"
              target={"_blank"}
              href="https://www.linkedin.com/in/vincenzo-chiovaro-22258a176/"
              className="contact-link"
            >
              <FontAwesomeIcon icon={faLinkedin} size="4x" />
              <span className="contact-link__label">LinkedIn</span>
            </a>
          </Col>
          <Col md={4} className="text-center mb-4">
            <a
              rel="noreferrer"
              target={"_blank"}
              href="https://github.com/vincenzochiovaro"
              className="contact-link"
            >
              <FontAwesomeIcon
                icon={faGithub}
                size="4x"
                className="icon-github"
              />
              <span className="contact-link__label">GitHub</span>
            </a>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ContactMe;
